module.exports = __webpack_public_path__ + "img/secondary-2.d4e25912.svg";